'use client'
import {
  type BlocksContent,
  BlocksRenderer,
} from '@strapi/blocks-react-renderer'
import { cn } from '@/lib/utils'
import HeadingElement from './heading-element'
import LinkElement from './link-element'

interface TextPageContentProps {
  content?: BlocksContent | null
  className?: string
}

const TextPageContent = ({ content, className }: TextPageContentProps) => {
  if (!content) return null
  return (
    <article className={cn('prose', className)}>
      <BlocksRenderer
        content={content}
        blocks={{
          heading: ({ children, level }) => {
            switch (level) {
              case 1:
                return <HeadingElement as="h1">{children}</HeadingElement>
              case 2:
                return <HeadingElement as="h2">{children}</HeadingElement>
              case 3:
                return <HeadingElement as="h3">{children}</HeadingElement>
              case 4:
                return <HeadingElement as="h4">{children}</HeadingElement>
              case 5:
                return <HeadingElement as="h5">{children}</HeadingElement>
              case 6:
                return <HeadingElement as="h6">{children}</HeadingElement>
              default:
                return <HeadingElement as="h1">{children}</HeadingElement>
            }
          },
          link: ({ children, url }) => {
            const isButton = url.startsWith('button:')

            return (
              <LinkElement url={url} isButton={isButton}>
                {children}
              </LinkElement>
            )
          },
        }}
      />
    </article>
  )
}

export default TextPageContent
